import singlePageProps from 'lib/singlePageProps';
import { ClerkComponentsTemplate } from '@components/clerk-components/template';

export default ClerkComponentsTemplate;

const slug = '/components/sign-up';

export async function getStaticProps({ preview = false }) {
  return singlePageProps({ preview, slug });
}
